// import React from 'react';

import { MenuItemInfo } from '@tableau/widgets';
import React from 'react';

import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { Messages } from '~src/codegen/Localize';
import { AddContentButton } from '~src/userManagement/components/AddContentButton';
import { AddUsersButtonActionProps } from '~src/userManagement/components/AddUsersButton';
import { BulkImportUsersAction } from '~src/userManagement/services/BulkImportUsersAction';
import { ServerUsers } from '~src/userManagement/services/resources/ServerUsers';

import { AddUsersFromIdentityPoolAction } from './AddUsersFromIdentityPoolAction';

export enum ButtonOptions {
  ADD_USERS = 'ADD_USERS',
  ADD_FROM_FILE = 'ADD_FROM_FILE',
}

export interface AddUsersFromIdentityPoolButtonProps extends Omit<AddUsersButtonActionProps, 'identityStoreType'> {
  readonly identityPools: IIdentityPool[];
}

function failureHandler() {
  // If someone cancels the action on the dialog, or closes it, focuses out, we do nothing.
  // That's fine and expected, no need for cleanup.
}

export function AddUsersFromIdentityPoolButton(props: AddUsersFromIdentityPoolButtonProps) {

  const menuItems: MenuItemInfo[] = [
    { displayValue: Messages.identityPools_AddUsersButton_Dropdown_AddUsers(), value: ButtonOptions.ADD_USERS },
    { displayValue: Messages.identityPools_AddUsersButton_Dropdown_AddFromFile(), value: ButtonOptions.ADD_FROM_FILE }
  ];

  async function onSelect(selection: string) {
    switch (selection as ButtonOptions) {
      case ButtonOptions.ADD_USERS:
        AddUsersFromIdentityPoolAction.instance.showAddUserFromIdentityPoolDialog(props).catch(failureHandler);
        break;
      case ButtonOptions.ADD_FROM_FILE:
        const modalInstancePromise = props.isServerUsersSpace ?
        BulkImportUsersAction.showBulkImportServerUsersDialog(props.selectedIdentityPool) :
        BulkImportUsersAction.showBulkImportSiteUsersDialog(props.selectedIdentityPool);
        modalInstancePromise.then(async () => {
          props.requestSpaceContents();
          if (props.isServerUsersSpace) {
            const siteRoleOptionsWithCounts = await ServerUsers.instance.getUserCountsByMaxSiteRoleWithoutSolr(props.mixedContentFilterMap);
            props.updateTotalUserCountForServerUserSpace(undefined, siteRoleOptionsWithCounts);
          }
        }).catch(failureHandler);
        break;
    }
  }

  return <AddContentButton
    buttonText={Messages.identityPools_AddUsersButton()}
    testId={'add-users-from-identity-pool'}
    menuItems={menuItems}
    onSelect={onSelect}
  />;
}
